import { Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import moment from "moment";
import React, { useMemo } from "react";
import logo from "../../img/logoNoText.png";
import { getMinMaxDatesWithoutUpdate } from "./Invoice";

const styles = StyleSheet.create({
    page: {
        fontWeight: 400,
        flexDirection: "column",
        color: "#000",
        fontSize: "12px",
        lineHeight: "1.4em",
        minHeight: "100vh",
        position: "relative"
    },

    twoline: {
        display: "flex",
        flexDirection: "column",
        paddingVertical: "15px"
    },
    twolineHeader: {
        fontSize: "14px",
        fontWeight: "700"
    },
    twolineParagraph: {
        fontSize: "12px",
        fontWeight: "400"
    },

    // global
    textRight: {
        textAlign: "right"
    },
    textCenter: {
        textAlign: "center"
    },
    fw400: {
        fontWeight: "400"
    },
    fw500: {
        fontWeight: "500"
    },
    fw600: {
        fontWeight: "600"
    },
    fw700: {
        fontWeight: "700"
    },
    border2Left: {
        border: "solid",
        borderLeft: "1px",
        borderColor: "#EDEDF3"
    },
    borderLeft: {
        border: "solid",
        borderLeft: "1px",
        borderColor: "#D1D7FF"
    },
    borderRight: {
        border: "solid",
        borderRight: "1px",
        borderColor: "#D1D7FF"
    },
    borderBottom: {
        border: "solid",
        borderBottom: "1px",
        borderColor: "#D1D7FF"
    },
    border: {
        border: "solid",
        borderWidth: "1px",
        borderColor: "#D1D7FF"
    },
    // table
    table: {
        // border: 'solid',
        // borderWidth: '1px',
        // borderColor: '#DFE4FF'
    },
    tableHeadRow: {
        backgroundColor: "#DFE4FF",
        color: "#4352BB",
        fontWeight: "500",
        display: "flex",
        flexDirection: "row",
        border: "solid",
        borderBottom: "1px",
        borderColor: "#DFE4FF"
    },
    tableBodyRow: {
        display: "flex",
        flexDirection: "row"
    },
    tableCol: {
        padding: "5px 10px"
    },
    w30: {
        width: "30%"
    },
    w33: {
        width: "33%"
    },
    w40: {
        width: "40%"
    },
    w60: {
        width: "60%"
    },
    w70: {
        width: "70%"
    },
    w15px: {
        width: "15px"
    },
    purpleTitle: {
        backgroundColor: "#DFE4FF",
        color: "#4D5DCC",
        textAlign: "center",
        padding: "5px"
    },
    textTotal: {
        fontSize: "16px",
        color: "#4D5DCC",
        fontWeight: "700"
    },
    listIcon: {
        backgroundColor: "#000",
        width: "5px",
        height: "5px",
        borderRadius: "50%",
        marginTop: "4px"
    },
    marginBot5: {
        marginBottom: "5px"
    },
    marginBot10: {
        marginBottom: "10px"
    },
    marginBot15: {
        marginBottom: "15px"
    },
    marginBot20: {
        marginBottom: "20px"
    },
    marginBot30: {
        marginBottom: "30px"
    },

    // header
    pageHeader: {
        backgroundColor: "#4D5DCC",
        color: "#fff",
        padding: "10px",
        textAlign: "center",
        fontWeight: 300
    },
    secLogo: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center"
    },
    secLogoIn: {
        width: "70px",
        height: "70px",
        borderRadius: "50%",
        border: "solid",
        borderColor: "#6575E3",
        borderWidth: "5px",
        marginBottom: "5px",
        overflow: "hidden"
    },
    logo: {
        width: "60px",
        height: "60px",
        borderRadius: "50%"
    },
    pageTitle: {
        fontSize: "18px",
        fontWeight: "500"
    },

    headerInfo: {
        padding: "20px",
        display: "flex",
        flexDirection: "row",
        alignItems: "start",
        justifyContent: "space-between"
    },
    clientInfo: {
        // width: '60%'
    },
    invoiceInfo: {
        // width: '40%',
        textAlign: "left"
    },

    // main
    pageMain: {
        padding: "0 30px 30px"
    },
    invoiceTitle: {
        fontSize: "20",
        textAlign: "center"
    },

    // footer
    pageFooter: {
        backgroundColor: "#4D5DCC",
        color: "#B7C0FF",
        fontSize: "10px",
        padding: "5px",
        textAlign: "center",
        position: "absolute",
        bottom: "0",
        left: "0",
        width: "100%"
    }
});

const getField = (name, prop) => {
    let l = "";
    prop.forEach(field => {
        if (field.name === name) l = field.value;
    });
    return l;
};

const comma = n => {
    const a = Math.floor(n);
    const b = Math.floor(10 * (n - a));
    const c = Math.floor(100 * (n - a)) - 10 * b;
    return a + "," + b + "" + c;
};

const getCompanyInfo = (props, key) => {
    const { company, therapist } = props;
    // return company info
    return company ? company[key] : therapist[key];
};

const getInvoiceNumber = props => {
    let invoiceNumber =
        "" +
        (props.number !== undefined
            ? props.number
            : props.company
                ? props.company?.invoiceCount
                : props.therapist?.invoiceCount);

    if (invoiceNumber.length < 4) {
        invoiceNumber = "0" + invoiceNumber;
    }
    return invoiceNumber;
};

export default props => {
    const inv = props.inv[0];
    const therapist = props.inv[0].therapist;
    const company = props.inv[0].company;
    const client = props.inv[0].client;
    const booking = props.inv[0].booking;
    const journal = props.inv[0].journal;
    const settings = props.inv[0].settings;

    const startDate = useMemo(
        () => getMinMaxDatesWithoutUpdate(props.inv.map(a => ({ from: a.booking.from, to: a.booking.to })))?.minFrom,
        [props.inv]
    );
    const endDate = useMemo(
        () => getMinMaxDatesWithoutUpdate(props.inv.map(a => ({ from: a.booking.from, to: a.booking.to })))?.maxTo
    );

    return (
        <Page size="A4" style={styles.page}>
            <View style={styles.pageHeader}>
                <View style={styles.secLogo}>
                    <View style={styles.secLogoIn}>
                        <Image
                            style={styles?.logo}
                            src={company ? company?.logo || logo : therapist?.logo || logo}></Image>
                    </View>
                </View>
                <Text style={styles.pageTitle}> {company ? company.companyName : therapist.companyName} </Text>
            </View>

            <View style={styles.headerInfo}>
                <View style={styles.clientInfo}>
                    <Text>
                        {client.nameFirst} {client.nameLast} {"\n"}
                        {client.address} {"\n"}
                        {client.post} {client.town}
                        {"\n"}
                        CPR: {client.CPR.substring(0, 6)} - {client.CPR.substring(6)}
                        {"\n"}
                    </Text>
                </View>
                <View style={styles.invoiceInfo}>
                    <Text>Dato: {moment(Number(booking.from)).format("DD/MM/YYYY")}</Text>
                </View>
            </View>

            {/* table */}
            <View style={styles.pageMain}>
                <Text style={[styles.invoiceTitle, styles.marginBot10]}>Samlet Opgørelse</Text>
                <View style={[styles.bookingInfo, styles.marginBot15]}>
                    <Text style={styles.textCenter}>
                        Samlet opgørelse for behandling i perioden:
                        {"\n"}
                        {moment(startDate).format("DD/MM/YYYY")} Til.
                        {moment(endDate).format("DD/MM/YYYY")}
                    </Text>
                </View>

                {props.inv.map(invs => {
                    return (
                        <>
                            <View style={[styles.table, styles.marginBot15]}>
                                <View style={styles.tableHeadRow}>
                                    <Text style={[styles.tableCol, styles.w40]}>
                                        {moment(Number(invs.booking.from)).format("DD/MM/YYYY")}
                                        {"\n"}
                                        Fakturanr: {getInvoiceNumber(invs)}
                                    </Text>
                                    <Text style={[styles.tableCol, styles.w30, styles.border2Left, styles.textCenter]}>
                                        Varighed
                                    </Text>
                                    <Text style={[styles.tableCol, styles.w30, styles.border2Left, styles.textRight]}>
                                        Pris
                                    </Text>
                                </View>
                                <View style={[styles.tableBodyRow, styles.border]}>
                                    <Text style={[styles.tableCol, styles.w40]}>{invs.treatment.name}</Text>
                                    <Text style={[styles.tableCol, styles.w30, styles.borderLeft, styles.textCenter]}>
                                        {invs.treatment.duration / 60} min
                                    </Text>
                                    <Text style={[styles.tableCol, styles.w30, styles.borderLeft, styles.textRight]}>
                                        {comma(invs.treatment.price)} DKK
                                    </Text>
                                </View>
                                {invs.settings.discount ? (
                                    <View style={styles.tableBodyRow}>
                                        <Text style={[styles.tableCol, styles.w70, styles.textRight, styles.fw600]}>
                                            Rabat:
                                        </Text>
                                        <Text style={[styles.tableCol, styles.w30, styles.textRight, styles.fw600]}>
                                            {comma(invs.settings.discount)} DKK
                                        </Text>
                                    </View>
                                ) : (
                                    <></>
                                )}
                            </View>

                            {/* Aktuel behandling */}
                            {invs.settings.aktuelBehandling !== false ? (
                                invs.hasOwnProperty('journal') ? (
                                    <View style={styles.marginBot15}>
                                        <View style={[styles.tableBodyRow, styles.marginBot5]}>
                                            <View style={styles.w15px}>
                                                <Text style={styles.listIcon}></Text>
                                            </View>
                                            <Text style={styles.text}>Aktuel behandling</Text>
                                        </View>
                                        <View style={styles.tableBodyRow}>
                                            <Text style={styles.w15px}></Text>
                                            <Text>{invs.journal.treatment}</Text>
                                        </View>
                                    </View>
                                ) : (
                                    <View style={styles.marginBot15}>
                                        <View style={[styles.tableBodyRow, styles.marginBot5]}>
                                            <View style={styles.w15px}>
                                                <Text style={styles.listIcon}></Text>
                                            </View>
                                            <Text style={styles.text}>Aktuel behandling</Text>
                                        </View>
                                        <View style={styles.tableBodyRow}>
                                            <Text style={styles.w15px}></Text>
                                            <Text>{getField("Aktuel behandling", invs.stamJournal)}</Text>
                                        </View>
                                    </View>
                                )
                            ) : (
                                <></>
                            )}
                        </>
                    );
                })}

                {
                    <View style={styles.tableBodyRow}>
                        <Text style={[styles.tableCol, styles.w70, styles.textRight, styles.fw600]}>Sub Total:</Text>
                        <Text style={[styles.tableCol, styles.w30, styles.textRight, styles.fw600]}>
                            {comma(
                                props.inv
                                    .map(invs => (invs.treatment.price - (invs.settings.discount || 0)))
                                    .reduce((a, b) => a + b)
                            )}{" "}
                            DKK
                        </Text>
                    </View>
                }
                {settings.moms ? (
                    <View style={styles.tableBodyRow}>
                        <Text style={[styles.tableCol, styles.w70, styles.textRight, styles.fw600]}>Moms 25%:</Text>
                        <Text style={[styles.tableCol, styles.w30, styles.textRight, styles.fw600]}>
                            {comma(
                                props.inv
                                    .map(invs => (invs.treatment.price - (invs.settings.discount || 0)) * 0.25)
                                    .reduce((a, b) => a + b)
                            )}{" "}
                            DKK
                        </Text>
                    </View>
                ) : (
                    <></>
                )}

                <View style={styles.tableBodyRow}>
                    <Text style={[styles.tableCol, styles.w70, styles.textRight, styles.textTotal]}>I alt:</Text>
                    <Text style={[styles.tableCol, styles.w30, styles.textRight, styles.textTotal]}>
                        {comma(
                            props.inv
                                .map(
                                    invs =>
                                        invs?.treatment?.price -
                                        (invs?.settings?.discount || 0) +
                                        (invs?.settings?.moms
                                            ? (invs?.treatment?.price - (invs?.settings?.discount || 0)) * 0.25
                                            : 0)
                                )
                                .reduce((a, b) => a + b)
                        )}{" "}
                        DKK
                    </Text>
                </View>

                <View style={styles.twoline}>
                    <Text style={styles.twolineHeader}>Grundlag for beregning</Text>
                    <Text style={styles.twolineParagraph}>
                        Beregning for behandlingsforløb i perioden
                        {" "}
                        {moment(startDate).format("DD/MM/YYYY")} Til.
                        {moment(endDate).format("DD/MM/YYYY")}
                    </Text>
                </View>
            </View>

            <View style={styles.pageFooter}>
                <Text>
                    {getCompanyInfo(inv, "companyName")}, {getCompanyInfo(inv, "address")},{" "}
                    {getCompanyInfo(inv, "zipCode")} {getCompanyInfo(inv, "town")}
                </Text>
                <Text>
                    CVR: {getCompanyInfo(inv, "CVR").trim()} - {getCompanyInfo(inv, "email")} -{" "}
                    {getCompanyInfo(inv, "phone")}
                </Text>
            </View>
        </Page>
    );
};
